export class GenericDTO {
  id?: number | string | undefined;
}
